var autoLoadDuration = 4;

var eventList = [
    "keydown",
    "mousemove",
    "wheel",
    "touchmove",
    "touchstart",
    "touchend"
];

var autoLoadTimeout = null;
var delayedScriptsStarted = false;

var delayedScriptListenerOptions = {
    passive: true
};

function cleanupDelayedScriptTriggers() {
    if (autoLoadTimeout !== null) {
        clearTimeout(autoLoadTimeout);
        autoLoadTimeout = null;
    }

    eventList.forEach(function(eventName) {
        window.removeEventListener(
            eventName,
            triggerScripts,
            delayedScriptListenerOptions
        );
    });
}

function activateDelayedScript(scriptTag) {
    if (!scriptTag) return;

    var scriptSrc =
        scriptTag.getAttribute("delay");

    if (!scriptSrc) return;

    var newScript =
        document.createElement("script");

    Array.prototype.slice
        .call(scriptTag.attributes)
        .forEach(function(attribute) {
            if (
                attribute.name === "delay" ||
                attribute.name === "src" ||
                attribute.name === "async"
            ) {
                return;
            }

            newScript.setAttribute(
                attribute.name,
                attribute.value
            );
        });

    /*
     * Important:
     * dynamically inserted classic scripts should
     * execute in insertion order.
     */
    newScript.async = false;

    newScript.src = scriptSrc;

    newScript.setAttribute(
        "data-techcrazy-delayed-script",
        "true"
    );

    if (scriptTag.parentNode) {
        scriptTag.parentNode.replaceChild(
            newScript,
            scriptTag
        );
    }
}

function runScripts() {
    /*
     * Prevent mouse/touch/timer events from
     * initiating more than one release cycle.
     */
    if (delayedScriptsStarted) {
        return;
    }

    delayedScriptsStarted = true;

    cleanupDelayedScriptTriggers();

    /*
     * Keep the original DOM ordering of all
     * delayed scripts.
     */
    var delayedScripts =
        Array.prototype.slice.call(
            document.querySelectorAll(
                "script[delay]"
            )
        );

    delayedScripts.forEach(
        function(scriptTag) {
            activateDelayedScript(
                scriptTag
            );
        }
    );
}

function triggerScripts() {
    runScripts();
}

eventList.forEach(function(eventName) {
    window.addEventListener(
        eventName,
        triggerScripts,
        delayedScriptListenerOptions
    );
});

/*
 * Keep the current four-second fallback
 * unchanged for this step.
 */
autoLoadTimeout = setTimeout(
    runScripts,
    autoLoadDuration * 1000
);